import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import styles from '../../../src/assets/styles/HomePage.module.scss';
import Header from '../Header';
import Footer from '../Footer'
import BtnPhone from '../BtnPhone';
import BtnMail from '../BtnMail';

import OteviraciDoba from '../OteviraciDoba';
import KdeNasNajdete from '../KdeNasNajdete';

const Kontakt = () => {

    return (
        <div>
            <Container fluid className={`g-0`}>
                <Header headerAbsolute={true} />
                <div className={`${styles.heroImage} ${styles.heroImageKontakty}`}>
                    <div className={styles.heroText}>
                        <h1>Kontakty</h1>
                        <p className='lead'>
                            Máte dotazy nebo potřebujete více informací?
                            <br></br>
                            Rádi vám pomůžeme.
                            <br></br>
                            Těšíme se na vaši návštěvu v naší džunglové herně!
                        </p>
                    </div>
                </div>
            </Container>
            <Container fluid className=''>
                <Row>
                    <Col xs="12" lg="6" className='text-center d-flex flex-column justify-content-center bg-hermiona-light p-4' id="kdeNasNajdete">
                        <p>
                            Zavolejte nám
                            <br></br>
                            <BtnPhone />
                        </p>
                        <p>
                            nebo napište na email:
                            <br></br>
                            <BtnMail />
                        </p>
                    </Col>

                    <Col xs="12" lg="6" className='bg-frodo-light p-4'>
                        <OteviraciDoba type="forMain" />
                    </Col>
                </Row>
                <Row className='p-4'>
                    <Col>
                        <KdeNasNajdete />
                    </Col>

                </Row>

            </Container>


            <Footer />
        </div >
    );
};

export default Kontakt;